import { connect } from 'react-redux'
import OrganizationsSearch from '../../components/organizations/OrganizationsSearch'
import { IStoreState } from '../../types'
import { getAllOrganizations, search } from '../../state/actions/organizations'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {}
}

export function mapDispatchToProps(dispatch: any): any {
  let timeout: any

  return {
    onChange: (e: any) => {
      const requestDelay = 500
      const regex = /[\\\/\$\|\&\%\#\.\?]/g
      const query = e.target.value.replaceAll(regex, '')
      clearTimeout(timeout)

      timeout = setTimeout(() => {
        if (query.trim().length === 0) {
          return dispatch(getAllOrganizations())
        }
        dispatch(search(query))
      }, requestDelay)
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganizationsSearch)



// WEBPACK FOOTER //
// ./src/containers/organizations/OrganizationsSearch.ts